import { useEffect, useRef } from 'react';

const TertiaryButtonWYSIWYG = (props) => {
  const { content } = props;
  const secondaryContentRef = useRef(null);

  const getAllTextNodes = (element) =>
    Array.from(element.childNodes).filter(
      (node) => node.nodeType === 3 && node.textContent.trim().length > 1
    );

  useEffect(() => {
    secondaryContentRef.current.querySelectorAll('a').forEach((link) => {
      const span = document.createElement('span');
      const textNodes = getAllTextNodes(link);

      textNodes.forEach((node) => {
        const span2 = document.createElement('span');
        node.after(span2);
        span2.appendChild(node);
      });

      span.classList.add('material-icons-round');
      span.innerHTML = 'chevron_right';
      link.appendChild(span);
    });
  }, []);

  return (
    <>
      <div
        ref={secondaryContentRef}
        className="tertiary-button-wysiwyg"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </>
  );
};

export default TertiaryButtonWYSIWYG;
